import { LitElement, css, html, unsafeCSS } from "lit";
import { PluginTask } from "../plugin-busy-manager";
import styles from "./styles.css?inline";
import { template } from "./template";

export class PluginBusyList extends LitElement {
  static styles = css`
    ${unsafeCSS(styles)}
  `;

  render() {
    return html`${template(this)}`;
  }

  data: { busyTasks: PluginTask[] };
}
